module.exports = __webpack_public_path__ + "static/media/fixBottomBarHardware.9bf08bb0.png";